import request from "@/router/axios"
export const all = () => {
    return request({
        url: `/api/basis/hospital/list`,
        method: 'post',
        data: {
            orderBy: "id",
            isDesc: false
        }
    })
}
export const getHosDepts = () => {
    return request({
        url: `/api/basis/hospital/getHosDepts`,
        method: 'get',
    })
}